<template>
  <v-dialog
      v-model="dialog"
      scrollable
      width="400"
  >
    <v-card>
      <v-card-title>Kombinationskataster erstellen</v-card-title>
      <v-divider></v-divider>
      <v-card-text v-if="dialog">
        <v-text-field
            v-model="name"
            :rules="[v => !!v || 'Name ist ein Pflichtfeld.']"
            hint="Der Name des Kombinationskatasters. *Pflichtfeld"
            persistent-hint
            label="Name"
            ref="name"
        ></v-text-field>
        <v-select
            v-model="selectedItems"
            :items="cadastres"
            chips
            label="Kataster"
            item-value="id"
            item-text="name"
            multiple
            style="margin-top: 12px"
        ></v-select>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="blue darken-1"
            text
            @click="dialog = false"
        >
          Abbrechen
        </v-btn>
        <v-btn
            color="blue darken-1"
            text
            :disabled="name === '' || selectedItems.length < 1"
            @click="dialog = false; $emit('create-combo', {name: name, ids: selectedItems})"
        >
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "CreateComboDialog",
  props: {
    cadastres: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dialog: false,
      selected: null,
      name: '',
      selectedItems: [],
    };
  },
  computed: {
  },
  methods: {
    open() {
      this.selectedItems = [];
      this.name = "";
      this.dialog = true;
    }
  },
}
</script>

<style scoped>

::v-deep .v-list-group--no-action > .v-list-group__items > .v-list-item {
  padding-left: 18px !important;
}

::v-deep .v-list-item__action {
  margin: 6px 0;
}

::v-deep .v-list-item__content {
  padding: 6px 0;
}

::v-deep .v-list-item {
  min-height: 38px;
  transform: translate(0, 0);
  padding: 0 10px;
}

::v-deep .v-list-group__items {
  padding-left: 18px;
}

</style>
